import { fetchCompanyStatsMAUGames } from '@/pages/intelligence/services/companies';

export async function getMAUGamesCardData(params, tabId) {
  // 加载数据，例如从 API
  // 使用 applyFilter 筛选数据
  // 渲染卡片
  try {
    const gamesRes = await fetchCompanyStatsMAUGames(params);
    //1 aggregated为可视化柱状和饼， 需要过滤掉allgame
    //2 表格数据排序和分页需要重新调接口，但可视化不需要更新
    //3 请求折线图接口，需要给top5游戏数据，页面改变筛选器才重新请求

    const tableData = gamesRes?.data?.game_share_data_list || [];
    // const fixedData = gamesRes?.data?.game_share_data_total || [];
    const gameTotal = gamesRes?.data?.total_count || 0;
    const lineData = gamesRes?.data?.game_share_metric_time_line || [];
    const barOrPieData = tableData || [];

    const foundMetric = lineData?.find((item: any) => item?.metric === 'MAU');

    return {
      cardStats: {
        isLoading: false,
        isError: false,
        isNoData: !gameTotal,
      },
      lineData: foundMetric?.history || [],
      tableData: tableData,
      total: gameTotal,
      barOrPieData: barOrPieData,
      startDate: gamesRes?.data?.start_data_time || '',
      endDate: gamesRes?.data?.end_data_time || '',
    };
  } catch (err) {
    return {
      cardStats: {
        isLoading: false,
        isError: true,
        isNoData: true,
      },
      lineData: [],
      tableData: [],
      barOrPieData: [],
      total: 0,
      startDate: '',
      endDate: '',
    };
  }
}
